// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"780": "f09c0ecd1199bd5a","833": "a6b0cf008cb83be6",}[chunkId] + ".css"
}